import { render, staticRenderFns } from "./ExamenesList.vue?vue&type=template&id=84c30428"
import script from "./ExamenesList.vue?vue&type=script&lang=js"
export * from "./ExamenesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports